package presentation.screens.common.auth


import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import appConfig.AppConfig
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import com.friendly.shared.component.CustomDefaultBtn
import com.friendly.shared.component.ErrorSuggestion
import common.asset.ImageAsset
import component.country.DialCodeHelper
import component.input.MobileTextField
import component.loader.AppLoader
import component.navigation.TopNavBar
import feature.auth.handler.AuthHandler
import feature.auth.viewModel.AuthViewModel
import theme.ThemeColor

class LoginScreen : Screen {
    @Composable
    override fun Content() {
        val viewModel = AuthViewModel()
        val navigator = LocalNavigator.current

        var mobile by remember { mutableStateOf(TextFieldValue("")) }
        var dialCode by remember { mutableStateOf(DialCodeHelper().getSelectedCountryCode()) }
        viewModel.goToHome = {
            navigator?.popAll()
        }
        viewModel.goBack = {
            navigator?.pop()
        }
        viewModel.goToRegister = {
            val screen = SignUpScreen()
            AuthHandler.shared().mobile = mobile.text
            AuthHandler.shared().dialCode = dialCode.countryPhoneCode
            navigator?.push(screen)
        }
        viewModel.goToSetMPin = {
            val screen = SetMPinScreen()
            AuthHandler.shared().mobile = mobile.text
            AuthHandler.shared().dialCode = dialCode.countryPhoneCode
            navigator?.push(screen)
        }
        viewModel.goToLoginWithMPin = {
            val screen = VerifyMPinScreen()
            AuthHandler.shared().mobile = mobile.text
            AuthHandler.shared().dialCode = dialCode.countryPhoneCode
            navigator?.push(screen)
        }
        viewModel.goToOtp = {
            val screen = OTPScreen()
            AuthHandler.shared().mobile = mobile.text
            AuthHandler.shared().dialCode = dialCode.countryPhoneCode
            navigator?.push(screen)
        }

        var submitButtonTitle by remember { mutableStateOf("") }
        var isValidMobile by remember { mutableStateOf(false) }

        var checkBox by remember {
            mutableStateOf(false)
        }
        val mobileErrorState = remember {
            mutableStateOf(false)
        }

        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(0.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            TopNavBar("Sign In", onBackPress = { navigator?.pop() })
            AppLoader(viewModel)
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(8.dp),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Spacer(modifier = Modifier.height(20.dp))
                Text(
                    text = "Welcome to " + AppConfig().appName,
                    fontSize = 26.sp,
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.padding(start = 30.dp, end = 30.dp)
                )
                Text(
                    text = "Please provide your mobile number to continue",
                    color = ThemeColor.shared().TextColor,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.padding(start = 30.dp, end = 30.dp, top = 12.dp)
                )
                Spacer(modifier = Modifier.height(50.dp))
                MobileTextField(
                    placeholder = "9000000000",
                    trailingIcon = ImageAsset.phone,
                    label = "Mobile Number",
                    errorState = mobileErrorState,
                    keyboardType = KeyboardType.Phone,
                    visualTransformation = VisualTransformation.None,
                    onChanged = { mob ->
                        mobile = mob
                        isValidMobile = (mob.text.length in 9..11)
                    },
                    onDialCodeChange = {
                        dialCode = it
                    }
                )

                Spacer(modifier = Modifier.height(10.dp))
                if (mobileErrorState.value) {
                    ErrorSuggestion("Please enter valid mobile number")
                }
                CustomDefaultBtn(shapeSize = 50f, btnText = "Continue") {
                    mobileErrorState.value = !isValidMobile
                    if (isValidMobile) {
                        viewModel.checkAccount(mobile.text, dialCode.countryPhoneCode)
                    } else {

                    }
                }
            }
        }
    }
}


